import { render } from "./CreacionClientes.vue?vue&type=template&id=2f4a1236"
import script from "./CreacionClientes.vue?vue&type=script&lang=js"
export * from "./CreacionClientes.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__